import { DesignProvider, defaultDesignValues } from '@systemeio/digital-store-shared'
import fs from 'fs'
import ContentWrapper from 'modules/stores/store/components/content-wrapper'
import StoreEditDesignButton from 'modules/stores/store/components/design/store-edit-design-button'
import PreviewBox from 'modules/stores/store/components/preview-box'
import PreviewBoxMobile from 'modules/stores/store/components/preview-box-mobile'
import StoreBreadcrumbs from 'modules/stores/store/components/store-breadcrumbs'
import StoreEditButton from 'modules/stores/store/components/store-edit-button'
import StoreViewButton from 'modules/stores/store/components/store-view-button'
import { StoreLoco } from 'modules/stores/store/constants/store-loco'
import { StoreEditItemProvider } from 'modules/stores/store/context/store-item-edit-context'
import { StorePreviewProvider } from 'modules/stores/store/context/store-preview-context'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { NextPage } from 'next'
import { useAdaptiveStickyColomn } from 'shared/hooks/use-adaptive-sticky-colomn'
import {
  getBaseServerSideProps,
  getCombinedServerSideProps,
} from 'shared/utils/get-base-server-side-props'

interface StoreProps {
  css: string
  lightLectureCss: string
}

export const STORE_TOOLBAR_ID = 'store-toolbar'

const Store: NextPage<StoreProps> = ({ ...props }) => {
  const { adaptiveElementRef } = useAdaptiveStickyColomn({ indent: 20 })

  const { storeId, tab } = useStoreQuery()
  const { data: storeView } = useStore(storeId)

  return (
    <StorePreviewProvider css={props.css} lightLectureCss={props.lightLectureCss}>
      <DesignProvider design={storeView?.design ?? defaultDesignValues.default}>
        <div className={'flex flex-col gap-5'}>
          <div
            className={
              'bg-background-primary z-sticky-override shadow-around-sm sticky top-0 -ml-5 -mr-5 -mt-5 mb-2 flex w-screen flex-wrap items-center justify-between gap-y-1 self-center p-5 py-4 sm:flex-nowrap sm:py-5 lg:static lg:m-0 lg:w-full lg:bg-transparent lg:p-0 lg:shadow-none'
            }
            id={STORE_TOOLBAR_ID}
          >
            <StoreBreadcrumbs />
            <div className={'flex gap-3'}>
              <StoreViewButton />
              {tab !== StoreTabEnum.storeSettings && <StoreEditButton />}
              {tab !== StoreTabEnum.theme && <StoreEditDesignButton />}
              {tab !== StoreTabEnum.theme && <PreviewBoxMobile />}
            </div>
          </div>
          <div className={'flex gap-5'}>
            <div
              ref={adaptiveElementRef}
              className={
                'sticky top-5 hidden h-[calc(100vh-170px)] max-h-[720px] min-h-[500px] lg:block'
              }
            >
              <PreviewBox />
            </div>
            <StoreEditItemProvider>
              <ContentWrapper />
            </StoreEditItemProvider>
          </div>
        </div>
      </DesignProvider>
    </StorePreviewProvider>
  )
}

export const getServerSideProps = getCombinedServerSideProps(
  getBaseServerSideProps(StoreLoco, 'header.top_menu.stores'),
  async (): Promise<{ props: StoreProps }> => {
    const css = fs.readFileSync(
      '../../node_modules/@systemeio/digital-store-shared/dist/style.css',
      'utf8',
    )
    const lightLectureCss = fs.readFileSync(
      '../../node_modules/@systemeio/light-lecture-viewer/build/index.css',
      'utf8',
    )

    return {
      props: {
        css,
        lightLectureCss,
      },
    }
  },
)

export default Store
